import React, { Fragment } from "react";
import {
  Button,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";

const AddBtnSkill = ({ skillCat, handleClickAddBtn }) => {
  //console.log(skillCat);
  return (
    <Fragment>
      <UncontrolledPopover trigger="legacy" placement="top" target="addSkill">
        <PopoverHeader>Add Skill</PopoverHeader>
        <PopoverBody>
          <div className="skill-popover">
            {skillCat.map((el, i) => (
              <Button
                color="secondary"
                className="m-1"
                outline
                onClick={() => handleClickAddBtn(el.skillCategoryId,el.skillCategoryName.toLowerCase())}
                key={i}
              >
                {el.skillCategoryName}
              </Button>
            ))}
          </div>
        </PopoverBody>
      </UncontrolledPopover>
      <Button color="primary" id="addSkill" outline className="skill-add-btn" style={{background : "#007bff",width:"70px",height :"47px"}}>
        <i className="fa fa-plus" style={{color : "white"}}></i>
      </Button>
    </Fragment>
  );
};

export default AddBtnSkill;
